import React, { useEffect } from 'react';
import { Field } from 'formik';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import useThirdPartyAdmin from 'hooks/UseThirdPartyAdmin';
import { find } from 'lodash';

const ThirdPartyAdmin = ({ onChange, ...rest }) => {
    const { isLoading, data, refetch } = useThirdPartyAdmin();

    useEffect(() => {
        if (!data?.data) {
            refetch();
        }
    }, []);
    const thirdPartyAdmin = isLoading ? [] : data?.data || [];

    const handleChange = ({ target: { value } }) => {
        if (value) {
            const tpa = find(thirdPartyAdmin, {
                thirdPartyAdminID: parseInt(value),
            });
            onChange(value, tpa);
        } else {
            onChange(value, '');
        }
    };
    return (
        <Field
            name='thirdPartyAdminName'
            type='text'
            component={FormikSelectField}
            options={thirdPartyAdmin}
            defaultoption='--Select--'
            className='required'
            show = {true}
            keys={{
                id: 'thirdPartyAdminID',
                label: 'thirdPartyAdminName',
            }}
            onChange={handleChange}
            {...rest}
        />
    );
};

export default ThirdPartyAdmin;
